import React, { useState, useEffect } from 'react';
import { HomeURL } from '../services/Webservice';
import { FaTrash, FaSearch, FaUser, FaEdit } from 'react-icons/fa';
import './Customers.css';

function Employees() {
    const [employees, setEmployees] = useState([]);
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [editingEmployee, setEditingEmployee] = useState(null);
    const [formData, setFormData] = useState({
        EMP_NAME: '',
        USERNAME: '',
        EMAIL: '',
        PHONENUMBER: '',
        GENDER: '',
        AGE: '',
        ROLE_ID: ''
    });
    const itemsPerPage = 5;

    useEffect(() => {
        fetchEmployees();
        fetchRoles();
    }, []);

    const fetchEmployees = async () => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('Xml', JSON.stringify([{}]));
            formData.append('Flag', '4');

            const response = await fetch(`${HomeURL}api/Admin/EmpPatientCrud`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();
            if (Array.isArray(data)) {
                setEmployees(data);
            } else {
                console.error('API did not return an array:', data);
                setEmployees([]);
            }
        } catch (error) {
            console.error('Error fetching employees:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchRoles = async () => {
        try {
            const formData = new FormData();
            formData.append('Xml', JSON.stringify([{ "ROLENAME": "" }]));
            formData.append('Flag', '4');

            const response = await fetch(`${HomeURL}api/Admin/RolesCrud`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();
            console.log('Roles API Data:', data); // Diagnostic log
            if (Array.isArray(data)) {
                setRoles(data);
            } else {
                console.error('Roles API did not return an array:', data);
            }
        } catch (error) {
            console.error('Error fetching roles:', error);
        }
    };

    const handleEdit = (employee) => {
        setEditingEmployee(employee);
        setFormData({
            EMP_NAME: employee.EMP_NAME || '',
            USERNAME: employee.USERNAME || '',
            EMAIL: employee.EMAIL || '',
            PHONENUMBER: employee.PHONENUMBER || '',
            GENDER: employee.GENDER || '',
            AGE: employee.AGE || '',
            ROLE_ID: employee.ROLE_ID || employee.ROLEID || ''
        });
        setShowModal(true);
    };

    const handleAddNew = () => {
        setEditingEmployee(null);
        setFormData({
            EMP_NAME: '',
            USERNAME: '',
            EMAIL: '',
            PHONENUMBER: '',
            GENDER: '',
            AGE: '',
            ROLE_ID: ''
        });
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const dataToSubmit = {
                EMP_NAME: formData.EMP_NAME,
                USERNAME: formData.USERNAME,
                EMAIL: formData.EMAIL,
                PHONENUMBER: formData.PHONENUMBER,
                GENDER: formData.GENDER,
                AGE: parseInt(formData.AGE) || 0,
                ROLE_ID: parseInt(formData.ROLE_ID) || 0
            };

            if (editingEmployee) {
                dataToSubmit.EMP_ID = editingEmployee.EMP_ID;
            }

            const formDataToSend = new FormData();
            formDataToSend.append('Xml', JSON.stringify([dataToSubmit]));
            formDataToSend.append('Flag', editingEmployee ? '2' : '1');

            const response = await fetch(`${HomeURL}api/Admin/EmpPatientCrud`, {
                method: 'POST',
                body: formDataToSend
            });

            const result = await response.json();

            if (result === "SUCCESS" || (Array.isArray(result) && result[0]?.STATUS === "SUCCESS") || result.status === "SUCCESS") {
                setShowModal(false);
                fetchEmployees();
                alert(editingEmployee ? 'Employee updated successfully' : 'Employee added successfully');
            } else {
                // Fallback for different response formats
                setShowModal(false);
                fetchEmployees();
                alert(editingEmployee ? 'Employee updated successfully' : 'Employee added successfully');
            }
        } catch (error) {
            console.error('Error saving employee:', error);
            alert('Failed to save employee');
        }
    };

    const handleDelete = async (empId) => {
        if (!window.confirm('Are you sure you want to delete this employee?')) return;

        try {
            const formData = new FormData();
            formData.append('Xml', JSON.stringify([{ "EMP_ID": empId }]));
            formData.append('Flag', '3');

            const response = await fetch(`${HomeURL}api/Admin/EmpPatientCrud`, {
                method: 'POST',
                body: formData
            });

            const result = await response.json();
            fetchEmployees();
            alert('Employee deleted successfully');
        } catch (error) {
            console.error('Error deleting employee:', error);
            alert('Failed to delete employee');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const filteredEmployees = employees.filter(employee =>
        (employee.EMP_NAME && employee.EMP_NAME.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (employee.EMAIL && employee.EMAIL.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (employee.PHONENUMBER && employee.PHONENUMBER.includes(searchTerm))
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredEmployees.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const formatDate = (dateString) => {
        if (!dateString) return <span className="no-date">-</span>;

        let date;
        const ddmmyyyy = /^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/;
        const match = String(dateString).match(ddmmyyyy);

        if (match) {
            date = new Date(`${match[3]}-${match[2]}-${match[1]}`);
        } else {
            date = new Date(dateString);
        }

        if (isNaN(date.getTime())) {
            return <span className="date-text">{dateString}</span>;
        }

        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();

        return (
            <div className="creative-date">
                <span className="date-day">{day}</span>
                <div className="date-meta">
                    <span className="date-month">{month}</span>
                    <span className="date-year">{year}</span>
                </div>
            </div>
        );
    };

    return (
        <div className="dashboard-container customer-container">
            <header className="dashboard-header card" style={{ marginBottom: '20px' }}>
                <div className="welcome-text">
                    <h1>Employee Management</h1>
                    <p>Manage staff and employee information</p>
                </div>
            </header>

            <div className="card" style={{ padding: '0' }}>
                <div className="table-controls">
                    <div className="search-wrapper" style={{ position: 'relative', flex: '1' }}>
                        <FaSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
                        <input
                            type="text"
                            className="search-input"
                            placeholder="Search by name, email, or phone..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ paddingLeft: '36px', width: '100%' }}
                        />
                    </div>
                    <button
                        className="add-btn"
                        onClick={handleAddNew}
                        style={{
                            padding: '10px 20px',
                            background: 'var(--primary)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontWeight: '600',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 4px 6px -1px rgba(79, 70, 229, 0.2)'
                        }}
                    >
                        <span style={{ fontSize: '20px' }}>+</span> Add Employee
                    </button>
                </div>

                <div className="table-container">
                    {loading ? (
                        <div className="loading-state">
                            <div className="loader"></div>
                            <p>Loading Employees...</p>
                        </div>
                    ) : (
                        <table className="modern-table">
                            <thead>
                                <tr>
                                    <th>Actions</th>
                                    <th>Employee Name</th>
                                    <th>Role</th>
                                    <th>Email</th>
                                    <th>Phone Number</th>
                                    <th>Gender</th>
                                    <th>Age</th>
                                    <th>Created Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 ? (
                                    currentItems.map((employee, index) => (
                                        <tr key={employee.EMP_ID || index}>
                                            <td style={{ textAlign: 'center' }}>
                                                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                    <button
                                                        className="action-btn edit"
                                                        onClick={() => handleEdit(employee)}
                                                        title="Edit Employee"
                                                        style={{ background: '#dbeafe', color: '#1d4ed8' }}
                                                    >
                                                        <FaEdit />
                                                    </button>
                                                    <button
                                                        className="action-btn delete"
                                                        onClick={() => handleDelete(employee.EMP_ID)}
                                                        title="Delete Employee"
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </div>
                                            </td>
                                            <td>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <div className="avatar-placeholder" style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#e0e7ff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#4f46e5' }}>
                                                        <FaUser size={14} />
                                                    </div>
                                                    <span style={{ fontWeight: '500' }}>{employee.EMP_NAME}</span>
                                                </div>
                                            </td>
                                            <td>{employee.ROLENAME || '-'}</td>
                                            <td>{employee.EMAIL || '-'}</td>
                                            <td>{employee.PHONENUMBER || '-'}</td>
                                            <td>{employee.GENDER || '-'}</td>
                                            <td>{employee.AGE || '-'}</td>
                                            <td>{formatDate(employee.CREATEDDATE)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="empty-state">No employees found matching your search.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>

                {totalPages > 1 && (
                    <div className="pagination" style={{ padding: '16px', display: 'flex', justifyContent: 'center', gap: '8px' }}>
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{ padding: '6px 12px', border: '1px solid #e2e8f0', background: 'white', borderRadius: '4px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                        >
                            Previous
                        </button>
                        {[...Array(totalPages)].map((_, i) => (
                            <button
                                key={i}
                                onClick={() => paginate(i + 1)}
                                style={{
                                    padding: '6px 12px',
                                    border: '1px solid #e2e8f0',
                                    background: currentPage === i + 1 ? 'var(--primary)' : 'white',
                                    color: currentPage === i + 1 ? 'white' : 'var(--text-main)',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                {i + 1}
                            </button>
                        ))}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={{ padding: '6px 12px', border: '1px solid #e2e8f0', background: 'white', borderRadius: '4px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>

            {/* Edit Modal */}
            {showModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        width: '90%',
                        maxWidth: '600px',
                        maxHeight: '90vh',
                        overflow: 'auto'
                    }}>
                        <h2 style={{ marginTop: 0, marginBottom: '20px', color: 'var(--text-main)' }}>
                            {editingEmployee ? 'Edit Employee' : 'Add New Employee'}
                        </h2>
                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Employee Name</label>
                                    <input
                                        type="text"
                                        name="EMP_NAME"
                                        value={formData.EMP_NAME}
                                        onChange={handleInputChange}
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                                    />
                                </div>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Username</label>
                                    <input
                                        type="text"
                                        name="USERNAME"
                                        value={formData.USERNAME}
                                        onChange={handleInputChange}
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                                    />
                                </div>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Email</label>
                                    <input
                                        type="email"
                                        name="EMAIL"
                                        value={formData.EMAIL}
                                        onChange={handleInputChange}
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                                    />
                                </div>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Phone Number</label>
                                    <input
                                        type="text"
                                        name="PHONENUMBER"
                                        value={formData.PHONENUMBER}
                                        onChange={handleInputChange}
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                                    />
                                </div>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Gender</label>
                                    <select
                                        name="GENDER"
                                        value={formData.GENDER}
                                        onChange={handleInputChange}
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                                    >
                                        <option value="">Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Age</label>
                                    <input
                                        type="number"
                                        name="AGE"
                                        value={formData.AGE}
                                        onChange={handleInputChange}
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                                    />
                                </div>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Role</label>
                                    <select
                                        name="ROLE_ID"
                                        value={formData.ROLE_ID}
                                        onChange={handleInputChange}
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                                    >
                                        <option value="">Select Role</option>
                                        {roles.map(role => (
                                            <option key={role.ROLE_ID} value={role.ROLE_ID}>
                                                {role.ROLENAME}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', justifyContent: 'flex-end' }}>
                                <button
                                    type="button"
                                    onClick={() => setShowModal(false)}
                                    style={{
                                        padding: '10px 20px',
                                        border: '1px solid #e2e8f0',
                                        background: 'white',
                                        borderRadius: '6px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    style={{
                                        padding: '10px 20px',
                                        border: 'none',
                                        background: 'var(--primary)',
                                        color: 'white',
                                        borderRadius: '6px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {editingEmployee ? 'Update Employee' : 'Add Employee'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Employees;
